/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EBoxType {
  Xirgo = 'Xirgo',
  Calamp = 'CalAmp',
  CalampAsset = 'CalampAsset',
  MeridianZenith = 'Meridian Zenith',
  VDD = 'VDD'
}
